export const CAMPAIGN_ACTIVITY_KEYS = {
  all: ["campaignActivity"] as const,
  campaignTimelines: () =>
    [...CAMPAIGN_ACTIVITY_KEYS.all, "campaignTimeline"] as const,
  campaignTimeline: (campaignId: string) =>
    [...CAMPAIGN_ACTIVITY_KEYS.campaignTimelines(), campaignId] as const,
  influencerTimelines: () =>
    [...CAMPAIGN_ACTIVITY_KEYS.all, "influencerTimeline"] as const,
  influencerTimeline: (campaignId: string, influencerId: string) =>
    [
      ...CAMPAIGN_ACTIVITY_KEYS.influencerTimelines(),
      campaignId,
      influencerId,
    ] as const,
};
